import * as p from '@clack/prompts'
import type { applySchemaGeneration } from './apply-schema-generation.js'

export function printApplySummary(
  schemaName: string,
  summary: Awaited<ReturnType<typeof applySchemaGeneration>>['summary']
): void {
  const lines = [`${schemaName}:`]
  if (summary.tombstoneCleared) {
    lines.push(`  Tombstone cleared: ${summary.tombstoneCleared}`)
  }
  if (summary.writtenFresh.length > 0) {
    lines.push(`  written fresh: ${summary.writtenFresh.length}`)
  }
  if (summary.overwritten.length > 0) {
    lines.push(`  overwritten: ${summary.overwritten.length}`)
  }
  if (summary.mergedCleanly.length > 0) {
    lines.push(`  merged cleanly: ${summary.mergedCleanly.length}`)
  }
  if (summary.acceptedGenerated.length > 0) {
    lines.push(`  accepted generated: ${summary.acceptedGenerated.length}`)
  }
  if (summary.conflictPaths.length > 0) {
    lines.push(`  with conflicts: ${summary.conflictPaths.length}`)
  }
  if (summary.orphanedDeleted.length > 0) {
    lines.push(`  orphaned deleted: ${summary.orphanedDeleted.length}`)
  }
  if (summary.orphanedKept.length > 0) {
    lines.push(`  orphaned kept: ${summary.orphanedKept.length}`)
  }
  if (summary.skipped.length > 0) {
    lines.push(`  skipped: ${summary.skipped.join(', ')}`)
  }
  if (summary.skippedCleared.length > 0) {
    lines.push(`  skip entries cleared: ${summary.skippedCleared.join(', ')}`)
  }
  p.log.message(lines.join('\n'))
}
